import apiService from 'services/api.service'
import store from 'store'

export default {

    async getHotels() {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'hotels/getHotelList',
                method: 'get',
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async getAccSupplements(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/getAccSupplements',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async getAccSupplementPrices(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/getAccSupplementPrices',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async setAccSupplement(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/setAccSupplement',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async deleteAccSupplement(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/deleteAccSupplement',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async getMealSupplements(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/getMealSupplements',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async getMealSupplementPrices(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/getMealSupplementPrices',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async setMealSupplement(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/setMealSupplement',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },

    async deleteMealSupplement(params) {
        const locale = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'supplements/deleteMealSupplement',
                method: 'post',
                params: params,
                locale: locale
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty data!')
                }
            }).catch(error => {
                reject(error.data?.message);
            })
        })
    },
}
